import { AlertDemo } from "./AlertDemo";
import { MultipleWindowsDemo } from "./MultipleWindowsDemo";
import { StackedWindowsDemo } from "./StackedWindowsDemo";
import { WindowDecorDemo } from "./WindowDecorDemo";
import { WindowLooksDemo } from "./WindowLooksDemo";
import { WindowTabDemo } from "./WindowTabDemo";

export function WindowsAlerts() {
	return (
		<section id="windows-alerts" className="demo-category">
			<h1>Windows & Alerts</h1>
			<WindowDecorDemo />
			<WindowLooksDemo />
			<WindowTabDemo />
			<StackedWindowsDemo />
			<MultipleWindowsDemo />
			<AlertDemo />
		</section>
	);
}
